import { Spin } from 'antd'
import React, { Component } from 'react'

export class invalidDate extends Component {
  render() {
    const { openDailyReports, loading } = this.props
    return (
      <div>
        {!loading || openDailyReports === 'error' ? (
          <div
            style={{
              minHeight: 'calc(100vh - 500px)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                maxWidth: '560px',
                backgroundColor: '#fff',
                padding: '80px 30px',
                margin: '100px auto',
                borderRadius: '10px',
                flex: '1',
              }}
            >
              <div
                style={{
                  maxWidth: '400px',
                  margin: '0 auto',
                }}
              >
                <h1 className="font-size-36 mb-4 font-weight-bold">Report link has been expired</h1>
                <p className="mb-3">To view old reports please login to your portal</p>
                <a
                  href="https://portal.circadia.health"
                  className="btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  &larr; Click here to view older report
                </a>
              </div>
            </div>
          </div>
        ) : (
          <Spin spinning={loading} tip="Please wait while we fetch your data">
            <div style={{ height: '100vh', width: '100%' }} />
          </Spin>
        )}
      </div>
    )
  }
}

export default invalidDate
